import { useCallback, useEffect } from 'react'

function useClickOut(nodeRef, handleClose) {
  const handleClickOutside = useCallback(
    e => {
      if (nodeRef.current && nodeRef.current.contains(e.target)) {
        return
      }
      handleClose()
    },
    [handleClose, nodeRef]
  )

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [handleClickOutside])
}

export default useClickOut
